import { createEmptyCollection } from 'helpers/normalizeHelpers'
import { Reducer } from 'interfaces'
import { GetCCStateAction } from 'components/features/creditCard/creditCardStore/actions'
import { CreditCardDataState } from 'components/features/creditCard/creditCardStore/state'
import { CHANGE_TRANSACTION_CATEGORY } from 'actions/moneyflowActions'
import { processChangeTransactionCategory } from 'helpers/moneyflowHelpers'

const INITIAL_STATE = createEmptyCollection()
export const ccTransactionsReducer: Reducer<CreditCardDataState['transactions']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetCCStateAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return action.payload.response.transactions
    }

    case CHANGE_TRANSACTION_CATEGORY: {
      const nextCollection = processChangeTransactionCategory({
        type: null,
        prevCollection: prevState,
        action,
      })

      return nextCollection
    }
  }

  return prevState
}
